import { entries, notEqual, values } from "./javascript";
import formValidation from "./validations";
import constants from "../constants";
import placeholderImg from "../assets/images/placeholder-img.png";

const showFormErrors = (data, setData, ignore) => {
  let formErrors = {};
  entries(data).forEach(([key, value]) => {
    formErrors = {
      ...formErrors,
      ...formValidation(key, value, data, ignore),
    };
  });

  setData({ ...data, formErrors });
  return !values(formErrors).some((v) => notEqual(v, ""));
};

const capitalizeCamelCase = (str) => {
  let words = str?.split(/(?=[A-Z])/) || [];
  let capitalizedWords = words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  let capitalizedString = capitalizedWords.join(" ");
  return capitalizedString;
};

const getImageUrl = (image) => {
  if (image) {
    if (typeof image === "object") {
      return URL.createObjectURL(image)
    } else if (image?.includes("http") || image?.includes("static")) {
      return image;
    } else {
      return constants.baseUrl + image;
    }
  }
  return constants.baseUrl + placeholderImg;
};
const slugify = (name) => {
      return name
          .toLowerCase()
          .replace(/\s+/g, '-')        // replace spaces with hyphens
          .replace(/[^\w\-]+/g, '')    // remove non-word characters except hyphen
          .replace(/\-\-+/g, '-')      // replace multiple hyphens with single
          .replace(/^-+|-+$/g, '');    // trim hyphens from start/end
  }

  const deslugify = (slug) => {
        return slug
            .replace(/-/g, ' ')                          // replace hyphens with spaces
            .replace(/\b\w/g, char => char.toUpperCase()); // capitalize first letter of each word
    }

export {
  capitalizeCamelCase,
  showFormErrors,
  getImageUrl,
  slugify,
  deslugify
};
